
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["share-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"38","viewBox":"0 0 52 52"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"26","cy":"26","fill":"#f37b8a","r":"26"}}),_c('path',{attrs:{"d":"M27.535 39.085v-11.8h3.972l.6-4.574h-4.572v-2.887c0-1.321.361-2.287 2.287-2.287h2.408v-4.093c-.363 0-1.803-.12-3.491-.12-3.487 0-5.9 2.167-5.9 6.021v3.371h-3.972v4.572h3.972v11.8z"}})])
          )
        }
      }
    